var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h5", [_vm._v("Tag Management")]),
      _c("p", [_vm._v("Renaming tags has been moved to the glossary module!")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }